<wo-icon-field [icon]="icon">
  {{ address | geographicAddress }}
</wo-icon-field>
